<template>
    <PopoverRight ref="popoverContent" width="700px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">新增话题内容建模任务</h1>
            <div class="tips-wrapper clearfix">
                <div class="left">操作提示：</div>
                <div class="right">
                    <p>1.所选站点的楼盘无和问答题库中相同的话题时，则不会进行生成。</p>
                    <p>2. 问题会在所选时间段中每天的8:00-24:00间随机产生，回答在提问后48小时内随机生成。</p>
                    <p>3.执行任务前可先进行生成预览，查看本次任务预估能生成多少问答量，单次仅可选择一个站点生成预览。</p>
                </div>
            </div>
            <div class="form-container" >
                <div class="form-item" >
                    <div class="form-label" style="width:120px!important;text-align: center;">
                        <span class="label">生成方式：</span>
                    </div>
                    <div class="form-input-item">
                        <div label prop="">
                            <el-radio v-model="creatType" :label="1">指定站点</el-radio>
                            <el-radio v-model="creatType" :label="2">指定楼盘</el-radio>
                        </div>
                    </div>
                </div>
                <el-form class="form-container" :rules="rules" :model="form1List" ref="taskValidateForm1" v-if="creatType == 1">
                    <div class="form-item site-sp" >
                        <div class="site-label">
                            <span class="label">站点：</span>
                            <label class="warn">*</label>
                            <label class="ipt"
                            ><input
                                type="checkbox"
                                class="checkbox"
                                @click="selectAll"
                                :checked="checkAll"
                            />全选</label
                            >
                            <label class="ipt"
                            ><input
                                type="checkbox"
                                class="checkbox"
                                @click="selectStatus"
                                :checked="checkOwn"
                            />未代理站点</label
                            >
                        </div>
                        <br />
                        <div class="form-input-site">
                            <div v-if="this.siteList.length > 0">
                            <label v-for="(item, key) in siteList" :key="key">
                                <input
                                :id="key"
                                type="checkbox"
                                :value="item.id"
                                v-model="checkedSite"
                                />{{ item.name }}
                            </label>
                            </div>
                            <div v-else>暂无数据</div>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">每个站点选取楼盘数</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item  prop="house_num">
                                <el-input  v-model="form1List.house_num"></el-input>                   
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">每个楼盘新增问答数</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="asks_num">
                                <el-input v-model="form1List.asks_num" ></el-input>              
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">销售状态</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="sale_info">
                                <el-select v-model="form1List.sale_info" placeholder="请选择">
                                    <el-option
                                    v-for="item in saleState"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.id">
                                    </el-option>
                                </el-select>                          
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">审核状态</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="">
                                <el-radio-group v-model="form1List.status_verify">
                                    <el-radio :label="1">需要审核</el-radio>
                                    <el-radio :label="2">无需审核</el-radio>
                                </el-radio-group>                        
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">生成时间段</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="time">
                                <el-date-picker
                                    v-model="form1List.time"
                                    :picker-options="pickerOptions"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>          
                            </el-form-item>
                        </div>
                    </div>
                    <div class="align-center">
                        <el-button @click="hideMenu">取消</el-button>
                        <el-button type="primary" @click="creatPreview1('taskValidateForm1')">生成预览</el-button>
                        <el-button type="primary" @click="submitForm1('taskValidateForm1')" >确定</el-button>
                    </div>
                </el-form>
                <el-form class="form-container" :rules="rules" :model="form2List" ref="taskValidateForm2" v-else>
                    <div class="form-item" style="height: 152px">
                        <div class="form-label" style="width:120px!important;text-align: center;">
                            <span class="label">选择文件</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                        <el-form-item prop="path">
                            <div class="dongtai-input">
                            <div class="upload-group clearfix" v-if="file && file !== ''">
                                <div class="upload-item">
                                <img :src="excelUrl" alt />
                                <div class="shadow">
                                    <i class="el-icon-delete" @click="clearUploadDt"></i>
                                </div>
                                </div>
                            </div>
                            <div class="upload-group-2" v-else>
                                <i class="el-icon-plus"></i>
                                <input type="file" class="type-file" accept="xlsx" @change="checkDtFile($event)"
                                id="pictureUploadZt" />
                            </div>
                            <p class="download">下载<a :href="modelDownload">导入模板</a></p>
                            </div>
                        </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">每个楼盘新增问答数</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="asks_num">
                                <el-input v-model="form2List.asks_num" ></el-input>              
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">审核状态</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="">
                                <el-radio-group v-model="form2List.status_verify">
                                    <el-radio :label="1">需要审核</el-radio>
                                    <el-radio :label="2">无需审核</el-radio>
                                </el-radio-group>                        
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">生成时间段</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="time">
                                <el-date-picker
                                    v-model="form2List.time"
                                    :picker-options="pickerOptions"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>          
                            </el-form-item>
                        </div>
                    </div>
                    <div class="align-center">
                        <el-button @click="hideMenu">取消</el-button>
                        <el-button type="primary" @click="submitForm2('taskValidateForm2')" >确定</el-button>
                    </div>
                </el-form>
              
            </div>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import { getSite } from "@/service/site";
import { parseTime } from '@/utils'
import {addTopicTask,creatRecordPreviews,addTopicTaskByHouse} from '@/service/topicBank'
export default {
    name: 'add',
    components: {
        PopoverRight,
    },
    props: {
        callback: Function,
    },
    data () {
        const validateSort = (rule, value, callback) => {
               if (/^-?\d+$/.test(value) === false || value <1 || value >1000) {
                    callback(new Error(`请输入1-1000之间的数字`))
                }else {
                    callback()
                }
            }
        return {
            pickerOptions: {
                disabledDate(time) {
                　  return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                }
            },
            creatType: 1,
            isLoading:false,
            excelUrl:'',
            file:null,
            modelDownload:null,
            checkAll: false,
            checkOwn: false,
            siteList: [],
            checkedSite: [],
            form1List:{
                sale_info:0,
                house_num:'',
                asks_num:'',
                status_verify:1,
                time:[],
            },
            form2List:{
                asks_num:'',
                status_verify:1,
                time:[],
            },
            saleState:[{
                id:0,
                value:"不限"
            },{
                id:1,
                value:"在售"
            },{
                id:2,
                value:"待售"
            },{
                id:3,
                value:"售完"
            },{
                id:4,
                value:"尾盘"
            }],
            rules: {
                house_num: [
                    { required: true, message: '每个站点选取楼盘数', trigger: 'blur' },
                    { validator: validateSort,trigger: "blur"}
                ],
                asks_num: [
                    { required: true, message: '每个楼盘新增问答数', trigger: 'blur' },
                    { validator: validateSort,trigger: "blur"}
                ],
                time:[
                    { required: true, message: '时间不能为空', trigger: 'change' },
                ]
               
            },
            user:""
        }
    },
    watch: {
        checkedSite: function () {
        if (
            this.checkedSite.length == this.siteList.length &&
            this.checkedSite.length > 0
        ) {
            this.checkAll = true;
            this.checkOwn = false;
        } else {
            this.checkAll = false;
        }
        },
    },

    mounted(){
        const domain=document.domain;
        const host = window.serverConfig[window.siteMap[domain]].VUE_APP_FRIEND_LINK_URL;
        this.modelDownload = host+'话题指定楼盘模板.xls';
    },
    methods: {
        /** 打开右侧悬浮层 */
        openMenu (id) {
         
            this.$refs.popoverContent && this.$refs.popoverContent.open()
        },
        selectAll(event) {
            var _this = this;
            if (!event.currentTarget.checked) {
                this.checkedSite = [];
                this.checkOwn = false;
            } else {
                _this.checkedSite = [];
                _this.siteList.forEach(function (item) {
                _this.checkedSite.push(item.id);
                });
            }
        },
        selectStatus(event) {
            var _this = this;
            if (!event.currentTarget.checked) {
                _this.checkedSite = [];
                _this.checkOwn = false;
            } else {
                getSite({ agent_status: 1, per_page: 1000 }).then((data) => {
                let noStatus = data.data;
                _this.checkedSite = [];
                noStatus.forEach((el) => {
                    _this.checkedSite.push(el.id);
                });
                _this.checkOwn = true;
                });
            }
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.resetForm()
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
            this.$refs.taskValidateForm && this.$refs.taskValidateForm.clearValidate()
        },
        resetForm () {
            this.form1List = {
                sale_info:0,
                house_num:'',
                asks_num:'',
                status_verify:1,
                time:[],
            }
            this.form2List = {
                house_num:'',
                asks_num:'',
                status_verify:1,
                time:[],
            }
            this.checkedSite = [];
            this.file = null;
            this.creatType = 1;
        },
        submitForm1 (formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    if(this.checkedSite.length<=0){
                        this.$message({
                            type: "error",
                            message: "请选择站点",
                        });
                        return;
                    }
                    let query = this.form1List;
                    query.site_id_str =this.checkedSite.join("_");
                    if(this.form1List.time && this.form1List.time.length>1) {
                        query['create_time_period_start'] =parseTime( new Date(this.form1List.time[0]), '{y}-{m}-{d}')
                        query['create_time_period_end'] = parseTime( new Date(this.form1List.time[1]), '{y}-{m}-{d}')
                    }
                    addTopicTask(query).then((data) => {
                        this.$message({
                            message: '添加成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                        this.hideMenu()
                        this.callback && this.callback();
                    }).catch(err => {
                        this.$message({
                            message: err.message || '添加失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                    
                } else {
                    return false
                }
            })
        },
        submitForm2 (formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    if(!this.file){
                        this.$message({
                            type: "error",
                            message: "请上传楼盘文件！",
                        });
                        return;
                    }
                    const formData = new FormData();
                    formData.append("file", this.file);
                    formData.append("type", this.creatType);
                    formData.append("asks_num",  this.form2List.asks_num);
                    formData.append("status_verify",  this.form2List.status_verify);

                    if(this.form2List.time && this.form2List.time.length>1) {
                        formData.append("create_time_period_start",  parseTime( new Date(this.form2List.time[0]), '{y}-{m}-{d}'));
                        formData.append("create_time_period_end",  parseTime( new Date(this.form2List.time[1]), '{y}-{m}-{d}'));
                    }
                    addTopicTaskByHouse(formData).then((data) => {
                        this.$message({
                            message: '添加成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                        this.hideMenu()
                        this.callback && this.callback();
                    }).catch(err => {
                        this.$message({
                            message: err.message || '添加失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                    
                } else {
                    return false
                }
            })
        },
        creatPreview1(formName){
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    if(this.checkedSite.length<=0){
                        this.$message({
                            type: "error",
                            message: "请选择站点",
                        });
                        return;
                    }else if(this.checkedSite.length > 1){
                        this.$message({
                            message: '生成预览时仅对一个站点操作',
                            type: 'error',
                            duration: 3 * 1000
                        })
                        return
                    }
                    let query = this.form1List;
                    query.site_id =this.checkedSite.join("_");
                    if(this.form1List.time && this.form1List.time.length>1) {
                        query['start_time'] =parseTime( new Date(this.form1List.time[0]), '{y}-{m}-{d}')
                        query['end_time'] = parseTime( new Date(this.form1List.time[1]), '{y}-{m}-{d}')
                    }
                    creatRecordPreviews(query).then((data) => {
                        this.$message({
                            message: '生成预览成功，请稍后在任务生成预览列表查看预览情况',
                            type: 'success',
                            duration: 3 * 1000
                        })
                        this.hideMenu()
                    }).catch(err => {
                        this.$message({
                            message: err.message || '生成预览失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                    
                } else {
                    return false
                }
            
            })
        },
        checkDtFile(e) {
            const file = e.target;
            const filePath = file.value;
            if (!filePath) return false;
            if (!/.(xls)$/.test(filePath)) {
                this.$message({
                type: "error",
                message: "请选择xls格式",
                });
                return false;
            }
            this.zipImg();
            this.file = file.files[0]
            
        },
        clearUploadDt() {
            this.$set(this, "file", "");
        },
        zipImg() {
            if (process.env.NODE_ENV === "development") {
                this.excelUrl = process.env.VUE_APP_RESOURCE_URL + "/image/excel.jpg";
            } else {
                this.excelUrl =
                window.serverConfig[window.siteMap[domain]].VUE_APP_RESOURCE_URL +
                "/image/excel.jpg";
            }
        },
    }
}
</script>
<style scoped lang="less">
.upload-group-2 {
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .el-icon-plus {
    font-size: 30px;
    color: #999;
  }
  .type-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  input{
      height: 152px !important;;
  }
}
.upload-group {
  .upload-item {
    width: 150px;
    height: 150px;
    position: relative;
    float: left;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
    .shadow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: -webkit-box;
      -webkit-box-align: center;
      -webkit-box-pack: center;
      cursor: pointer;
      transition: all 0.1s linear;
      opacity: 0;
      .el-icon-delete {
        font-size: 21px;
        color: #fff;
        display: block;
      }
    }
    &:hover {
      .shadow {
        opacity: 1;
      }
    }
    .el-icon-close {
      position: absolute;
    }
  }
}
.popover-slider-bar .form-container .form-item .form-label {
  width: 28% !important;
}
.popover-slider-bar .form-container .form-item .form-input-item {
  width: 72% !important;
}
.popover-slider-bar .form-container .form-item .form-input-item .download{
    display: inline-block;
    position: absolute;
    left: 170px;
    bottom: 0;
}
.popover-slider-bar .form-container .form-item .form-input-item .download a{
  text-decoration: none;
  color:#409EFF
}
.site-sp {
  display: block !important;
  padding-left: 30px;
}
.site-label {
  width: 100%;
  height: 30px;
}
.site-label .ipt {
  margin-right: 20px;
}
.form-input-site {
  min-height: 100px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 20px;
  box-sizing: border-box;
}
.form-input-site label {
  margin-right: 15px;
  padding-bottom: 10px;
  display: inline-block;
}
.form-input-site label input {
  margin-right: 5px;
}
.popover-slider-bar .form-container .form-item .form-label {
    width: 25%;
}
.popover-slider-bar .form-container .form-item .form-input-item {
    width: 75%;
}
.tips-wrapper{
    width: 100%;
    margin-top:20px;
}
.tips-wrapper .left{
    width: 15%; 
    float: left;
    text-align: center;
    line-height:30px;
}
.tips-wrapper .right{
     float: left;
     width:85%;
}
.tips-wrapper .right p{
    line-height: 30px;
}
</style>